import type { EmailActivity } from '@common/types/activities';
import { Box, Typography } from '@mui/material';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
}

export default function DefaultEmailBody({ emailBody }: Props) {
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography variant="body2" color="text.primary">
                Hello {emailBody?.ClientName},
            </Typography>
            <Typography variant="body2" color="text.primary">
                <div
                    dangerouslySetInnerHTML={{
                        __html: cleanHTML(emailBody?.EmailBodyIntroduction || ''),
                    }}
                ></div>
            </Typography>
        </Box>
    );
}
